import React from "react";

let Hero = React.createClass({
    getInitialState() {
        return {};
    },
    propTypes: {
        src: React.PropTypes.string.isRequired
    },
    render() {
        return (
            <div className="eo-fluid-embed">
                <div className="eo-fluid-embed-wrap">
                    <iframe className="eo-fluid-embed-iframe" src={this.props.src + "?autoplay=1&modestbranding=1&rel=0"} frameBorder="0" allowFullScreen></iframe>
                </div>
            </div>
        );
    }
});

export default Hero;



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/components/FluidEmbed.js
 **/